// Versent V-mark — brand device (Avery's avatar motif + nav). Never a list bullet.
const V_PATH =
  'M50.3,104.2L113.6,1.9c-21.4,24-40,44.4-73.5,44.8C49.3,50.1,59.3,51,69,49L50.3,79.6C43,66.5,36.1,53.5,28.8,40.3c16.5,2.9,33.5-0.5,47.6-9.6C52.3,37.9,26.3,35.3,4,23.6L50.3,104.2z';

export function VMark({ color = '#00D700', size = 24 }: { color?: string; size?: number }) {
  return (
    <svg viewBox="0 0 118 106.2" width={size} height={size} aria-hidden="true" focusable="false">
      <path fill={color} d={V_PATH} />
    </svg>
  );
}

/** Rounded square tile with the V-mark, used as Avery's avatar. */
export function VTile({
  size = 34,
  bg = '#000000',
  v = '#00D700',
  className = '',
}: {
  size?: number;
  bg?: string;
  v?: string;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-ctl ${className}`}
      style={{ width: size, height: size, background: bg }}
      aria-hidden="true"
    >
      <VMark color={v} size={size * 0.56} />
    </span>
  );
}
